const AppFooter = () => {
    return (
        <div className="layout-footer">
            <img width={128} src="/img/logo.png" alt="jobvritta" />
            <span className="copyright">&#169; JobVritta.com - {new Date().getFullYear()}</span>
        </div>
    );
};

export default AppFooter;
